import { render, staticRenderFns } from "./GiveForm.vue?vue&type=template&id=77d70da4&scoped=true&"
import script from "./GiveForm.vue?vue&type=script&lang=js&"
export * from "./GiveForm.vue?vue&type=script&lang=js&"
import style0 from "./GiveForm.vue?vue&type=style&index=0&id=77d70da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d70da4",
  null
  
)

export default component.exports